import { Address } from '@interfaces/address';

export const addresses: Address[] = [
    {
        default: true,
        firstName: 'Helena',
        lastName: 'Garcia',
        email: 'stroyka@example.com',
        phone: '38 972 588-42-36',
        country: 'Bahrain',
        countryId: '',
        area: 'Capital Govornorate',
        areaId: '',
        city: 'Manama',
        cityId: '',
        postcode: '115302',
        address: 'ul. Varshavskaya, 15-2-178'
    },
    {
        default: false,
        firstName: 'Jupiter',
        lastName: 'Saturnov',
        email: 'stroyka@example.com',
        phone: 'ZX 971 972-57-26',
        country: 'Bahrain',
        countryId: '',
        area: 'Capital Govornorate',
        areaId: '',
        city: 'Manama',
        cityId: '',
        postcode: '4b4f53',
        address: 'Sun Orbit, 43.3241-85.239'
    }
];
